import parse from 'url-parse';
export function useQueryValues(url) {
  const parsedUrl = parse(url || window?.location?.href, true);
  return parsedUrl?.query || {};
}
